import { feathers, type ClientService } from '@feathersjs/feathers'
import type { SocketService } from '@feathersjs/socketio-client'
import authenticationClient from '@feathersjs/authentication-client'
import socketio from '@feathersjs/socketio-client'
import io from 'socket.io-client'
import { type ServiceStores } from '@restify/packages/composables/useStore'
import { type PiFiscalServiceShape } from '@restify/packages/stores/fiscal'

const host = import.meta.env.VITE_APP_API_BASE as string

// Use Rest for the SSR Server and socket.io for the browser
const connection = socketio(
  io(host, { timeout: 10000, transports: ['websocket'] }),
)

export interface ServiceTypes
  extends Record<keyof ServiceStores, ClientService> {
  ['auth-management']: ClientService
  ['process']: ClientService
  ['upload']: ClientService
  ['push-tokens']: ClientService
  ['push-tokens/vapid-public-key']: ClientService
  ['push-tokens/test']: ClientService
  ['invoice-scan']: SocketService & {
    match(data: { procurementId: string; documentId: string }): Promise<any>
  }
  ['pi-printer']: ClientService
  ['pi-fiscal']: ClientService & PiFiscalServiceShape
  ['checkout']: ClientService
}

export const feathersClient = feathers<ServiceTypes>()
  .configure(connection)
  .configure(
    authenticationClient({
      storage: window.localStorage,
      storageKey: 'accessToken',
    }),
  )

// register invoice-scan with custom `match` method (custom Feathers methods
// aren't auto-discovered through the type system).
// @ts-expect-error — see backoffice-app/plugins/feathersStore.ts
feathersClient.use('invoice-scan', connection.service('invoice-scan'), {
  methods: ['create', 'match'],
})

// pi-fiscal has v5 custom methods (getStatus, getTask) — same registration
// pattern as invoice-scan above.
// @ts-expect-error — see above
feathersClient.use('pi-fiscal', connection.service('pi-fiscal'), {
  methods: ['find', 'get', 'create', 'getStatus', 'getTask'],
})

export default () => {
  return feathersClient
}
